import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {HttpTokenInterceptor, ApiService, JwtService} from '@common-lib';
import {JwtHelper} from 'angular2-jwt';

import {AuthGuard, UserService} from './services';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true},
        ApiService,
        AuthGuard,
        JwtService,
        UserService,
        JwtHelper
    ],
    declarations: []
})
export class CoreModule {
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts